module.exports = __webpack_public_path__ + "static/media/umbrella.bb80259b.svg";